import React from 'react';
import Header from 'components/Header/Header';
import { Card, Container, Dimmer } from 'semantic-ui-react';
import classNames from 'classnames';
import './page-container.scss';

export default function PageContainer({
  children,
  title,
  className,
  leftComponent,
  rightComponent,
}) {
  return (
    <Container
      aria-label="Page contents"
      as="section"
      fluid
      className={classNames('page-container', className)}
    >
      <Header
        title={title}
        leftComponent={leftComponent}
        rightComponent={rightComponent}
      />
      <Card fluid>
        <main className="page-container__content-wrapper">
          <Dimmer.Dimmable>{children}</Dimmer.Dimmable>
        </main>
      </Card>
    </Container>
  );
}
